.input {
  cursor: pointer;
  line-height: unset;

  &:where([data-read-only]) {
    cursor: default;
  }
}
